import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../store/actions/index';

import PBXTrunkServiceNew from './PBXTrunkServiceNew';
import TrunkServiceEdit from './TrunkServiceEdit';
import ExpandingReactTable from '../ExpandingReactTable';

const DEFAULT_PAGE_SIZE = 10;

class TrunkServicePanel extends Component {

    fetchData = (filters, searchText, pageSize, pageNo, sortSettings) => {
        const allServices = this.props.currentServices || [];
        const page = pageNo || 1;
        const size = pageSize || DEFAULT_PAGE_SIZE;
        const start = (page - 1) * size;
        const results = allServices.slice(start, start + size);
        return Promise.resolve({
            data: {
                Results: results,
                PageCount: Math.max(Math.ceil(allServices.length / size), 1),
                CurrentPage: page,
                RecordCount: allServices.length
            }
        });
    };

    render() {
        var self = this;
        const allServices = self.props.currentServices || [];

        var addService = null;
        if (self.props.availableService
            && self.props.availableService.AllowMultipleInstances
            && self.props.allowNewService
        ) {
            addService = (
                <div>
                    <PBXTrunkServiceNew
                        serviceName="Trunk"
                        variant={self.props.availableServiceVariant}
                        existingCount={allServices.length}
                        canSelectTrueTransfer={self.props.services.canSelectTrueTransfer}
                        trueTransferSupported={self.props.services.trueTransferSupported}
                        restrictServiceTabs={self.props.restrictServiceTabs}
                        saveServiceCallback={self.props.saveServiceCallback}
                        limitToOneService={self.props.limitToOneService}
                    />
                </div>
            );
        }

        const columns = [
            {
                Header: () => null,
                id: 'service',
                wrapText: true,
                Cell: ({ row }) => (
                    <TrunkServiceEdit
                        key={row.original.Id}
                        totalPBXTrunk={allServices.length}
                        currentService={row.original}
                        variant={self.props.availableServiceVariant}
                        refetchServices={self.props.refetchServices}
                        canSelectTrueTransfer={self.props.services.canSelectTrueTransfer}
                        trueTransferSupported={self.props.services.trueTransferSupported}
                    />
                )
            }
        ];

        return (
            <div className="service-panel">
                <ExpandingReactTable
                    fetchData={self.fetchData}
                    columns={columns}
                    update={allServices.length}
                    defaultPageSize={DEFAULT_PAGE_SIZE}
                    showPagination={true}
                    noDataText="No trunk services found"
                    loadingText="Loading..."
                    className="-no-header"
                />
                {addService}
            </div>
        );
    }

}
const mapStateToProps = state => {
    const services = state.services;
    return {
        services
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        refetchServices: () => dispatch(actions.refetchServices())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(TrunkServicePanel);
